module.exports = __webpack_public_path__ + "static/media/setup-buildings.7b997e74.svg";